"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ToggleButton_1 = __importDefault(require("./ToggleButton"));

exports.default = ToggleButton_1.default;